module.exports = __webpack_public_path__ + "img/mirante-paxixi.688d52ba.jpg";